module.exports = "https://web-assets.ifttt.com/packs/media/fonts/avenir_next-demi-11b3a283.woff2";